var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3996_28657",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3996_28657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97 12.6C9.18 12.6 9.3575 12.5275 9.5025 12.3825C9.6475 12.2375 9.72 12.06 9.72 11.85C9.72 11.64 9.6475 11.4625 9.5025 11.3175C9.3575 11.1725 9.18 11.1 8.97 11.1C8.76 11.1 8.5825 11.1725 8.4375 11.3175C8.2925 11.4625 8.22 11.64 8.22 11.85C8.22 12.06 8.2925 12.2375 8.4375 12.3825C8.5825 12.5275 8.76 12.6 8.97 12.6ZM8.43 10.29H9.54C9.54 9.96 9.5775 9.7 9.6525 9.51C9.7275 9.32 9.94 9.06 10.29 8.73C10.55 8.47 10.755 8.2225 10.905 7.9875C11.055 7.7525 11.13 7.47 11.13 7.14C11.13 6.58 10.925 6.15 10.515 5.85C10.105 5.55 9.62 5.4 9.06 5.4C8.49 5.4 8.0275 5.55 7.6725 5.85C7.3175 6.15 7.07 6.51 6.93 6.93L7.92 7.32C7.97 7.14 8.0825 6.945 8.2575 6.735C8.4325 6.525 8.7 6.42 9.06 6.42C9.38 6.42 9.62 6.5075 9.78 6.6825C9.94 6.8575 10.02 7.05 10.02 7.26C10.02 7.46 9.96 7.6475 9.84 7.8225C9.72 7.9975 9.57 8.16 9.39 8.31C8.95 8.7 8.68 8.995 8.58 9.195C8.48 9.395 8.43 9.76 8.43 10.29ZM9 15C8.17 15 7.39 14.8425 6.66 14.5275C5.93 14.2125 5.295 13.785 4.755 13.245C4.215 12.705 3.7875 12.07 3.4725 11.34C3.1575 10.61 3 9.83 3 9C3 8.17 3.1575 7.39 3.4725 6.66C3.7875 5.93 4.215 5.295 4.755 4.755C5.295 4.215 5.93 3.7875 6.66 3.4725C7.39 3.1575 8.17 3 9 3C9.83 3 10.61 3.1575 11.34 3.4725C12.07 3.7875 12.705 4.215 13.245 4.755C13.785 5.295 14.2125 5.93 14.5275 6.66C14.8425 7.39 15 8.17 15 9C15 9.83 14.8425 10.61 14.5275 11.34C14.2125 12.07 13.785 12.705 13.245 13.245C12.705 13.785 12.07 14.2125 11.34 14.5275C10.61 14.8425 9.83 15 9 15ZM9 13.8C10.34 13.8 11.475 13.335 12.405 12.405C13.335 11.475 13.8 10.34 13.8 9C13.8 7.66 13.335 6.525 12.405 5.595C11.475 4.665 10.34 4.2 9 4.2C7.66 4.2 6.525 4.665 5.595 5.595C4.665 6.525 4.2 7.66 4.2 9C4.2 10.34 4.665 11.475 5.595 12.405C6.525 13.335 7.66 13.8 9 13.8Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutlinedIcon);
export default __webpack_public_path__ + "static/media/help_outlined_icon.afdb18d9c106f17af45c179392fdec69.svg";
export { ForwardRef as ReactComponent };